import Header from "../components/utils/Header";
import banner from '../media/banner/rooms.webp';
import Nav from "../components/utils/Nav";
import styles from '../css/Rooms.module.css';
import { CarouselRoomOne } from "../components/room/CarouselRoomOne";
import { CarouselRoomTwo } from "../components/room/CarouselRoomTwo";
import Gallery from "../components/UI/Gallery";
import Footer from "../components/utils/Footer";
import GoToBooking from "../components/utils/GoToBooking";
import { useTranslation } from 'react-i18next';

const Rooms = () => {
    const { t } = useTranslation("global")

    return <>
        <Nav active="room" />
        <Header title={t("rooms.title")} img={banner} />
        <p className={styles.subtitle}>{t("rooms.subtitle")}</p>
        <h2 className={styles.title}>Sliding Door</h2>
        <div className={styles.container}>
            <ul className={styles.columns}>
                <li>{t("rooms.one.0")}</li>
                <li>{t("rooms.one.1")}</li>
                <li>{t("rooms.one.2")}</li>
                <li>{t("rooms.one.3")}</li>
                <li>{t("rooms.one.4")}</li>
                <li>{t("rooms.one.5")}</li>
                <li>{t("rooms.one.6")}</li>
                <li>{t("rooms.one.7")}</li>
                <li>{t("rooms.one.8")}</li>
            </ul>
            <Gallery images={CarouselRoomOne} />
        </div>
        <GoToBooking img={banner} />
        <h2 className={styles.title}>Junior Suite</h2>
        <div className={styles.container}>
        <ul className={styles.columns}>
                <li>{t("rooms.two.0")}</li>
                <li>{t("rooms.two.1")}</li>
                <li>{t("rooms.two.2")}</li>
                <li>{t("rooms.two.3")}</li>
                <li>{t("rooms.two.4")}</li>
                <li>{t("rooms.two.5")}</li>
                <li>{t("rooms.two.6")}</li>
                <li>{t("rooms.two.7")}</li>
                <li>{t("rooms.two.8")}</li>
                <li>{t("rooms.two.9")}</li>
                <li>{t("rooms.two.10")}</li>
            </ul>
            <Gallery images={CarouselRoomTwo} />
        </div>
        <Footer />
    </>

}

export default Rooms;